import {
  CHANGE_ACTIVE_ITEM_TS_EXPERT,
  CHANGE_ACTIVE_ITEM_LIVELIST,
  CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX,
  CHANGE_ACTIVE_ITEM_OSCILLOSCOPE,
  CHANGE_ACTIVE_ITEM_BAR_GRAPH,
  CHANGE_ACTIVE_ITEM_DADOS,
  CHANGE_ACTIVE_ITEM_LOG,
  CHANGE_ACTIVE_ITEM_REPORT,
  CHANGE_ACTIVE_ITEM_CONFIG,
  CHANGE_ACTIVE_ITEM_CHANNEL,
  SOLVE_PROBLEM
} from "../actions/types";

export function activeMenuItemReducer(initialState = { activeItem: "/", channel: "" }, action) {
  switch (action.type) {
    case CHANGE_ACTIVE_ITEM_TS_EXPERT:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_LIVELIST:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_LIVELIST_MATRIX:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_OSCILLOSCOPE:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_BAR_GRAPH:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_DADOS:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_LOG:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_REPORT:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_CONFIG:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    case CHANGE_ACTIVE_ITEM_CHANNEL:
      return {
        activeItem: action.payload.activeItem,
        channel: action.payload.channel
      };
    default:
      return initialState;
  }
}

export function solveProblemReducer(initialState = { solve: false, problem: {} }, action) {
  switch (action.type) {
    case SOLVE_PROBLEM:
      return action.payload;
    default:
      return initialState;
  }
}